<template>
  <div class="nittyoku">
    <h3>日直</h3>
    <div class="multi-date-table" v-for="(item, index) in form.nittyoku" :key="index" v-if="form.nittyoku">
      <div class="head"><b>日直{{ (index + 1) }}</b></div>
      <div class="flex">
        <div class="item full-width">
          <b class="required">取得日</b>
          <date-picker v-model="item.shinsei_date" :error="getError(item, 'shinsei_date')"></date-picker>
        </div>

        <div class="item">
          <koyouKeiyakuTimeSelect v-if="isInit" :errors="item.errors" :targetDate="item.shinsei_date"
            @change="changeKoyouKeiyakuTime" :hideWorkTime="true">
          </koyouKeiyakuTimeSelect>
        </div>

      </div>
      <div class="row-button">
        <i class="fa-solid fa-delete-left" @click="removeTableRow(form.nittyoku, index)"
          v-if="(form.nittyoku.length > 1)"></i>
      </div>
    </div>
    <!-- <p class="item btn-table-add">
      <button type="button" class="btn primary" @click="addRow">
        <i class="fa-solid fa-plus"></i>追加
      </button>
    </p> -->
    <div class="item">
      <b>備考</b>
      <input-textarea v-model="form.notes" :error="getError(form, 'notes')"></input-textarea>
    </div>
  </div>
</template>

<script lang="ts">

import { defineComponent, nextTick, onMounted, ref, Ref, toRefs } from 'vue'
import { useForm } from "@/composable/form/form";
import { useTableRow } from "@/composable/common/tablerow";
import { Shinsei, Nittyoku, ShinseiKoyouKeiyakuTime } from '@/types/Shinsei';
import KoyouKeiyakuTimeSelect from "@/components/shinsei/create/parts/KoyouKeiyakuTimeSelect.vue"
import { KoyouKeiyakuTimeSelectEmitData, SyuugyouBasyoAndKoyouKeiyakuOption } from '@/types/SyuugyouBasyo';
import { Logger } from '@/utils/Logger';

export default defineComponent({
  props: {
    form: {
      type: Object as () => Shinsei,
      default: null
    },
  },
  emits: {
    changeKoyouKeiyakuTime: (selectedSyuugyouBasyo: SyuugyouBasyoAndKoyouKeiyakuOption | null, selectedKoyouKeiyakuTimeOption: ShinseiKoyouKeiyakuTime | null) => true,
  },
  setup(props, context) {
    const { form } = toRefs(props)

    // 編集モードで使用する就業場所（雇用契約）と就業時間の初期値
    let workTimeId: Ref<number | null> = ref(null)
    let koyouKeiyakuId: Ref<number | null> = ref(null)

    const isInit = ref(false)
    const { getError } = useForm();
    const { addRowNoRef, removeTableRow } = useTableRow();

    onMounted(async () => {
      Logger.debug('----------------------------\n日直申請コンポーネントの初期化開始')
      Logger.debug('日直申請 onMounted', { '申請': form.value })
      nextTick(() => {
        Logger.debug('日直申請 onMounted->nextTick', { '申請': form.value })
        if (!form.value.nittyoku) {
          Logger.debug('新規作成モードの初期化を行います')
          form.value.nittyoku = [{
            shinsei_date: null,
          }]
        } else {
          Logger.debug('編集モードの初期化を行います')
          workTimeId.value = form.value.shinsei_koyou_keiyaku_time.length > 0 ? form.value.shinsei_koyou_keiyaku_time[0].koyou_keiyaku_time_id : null
          koyouKeiyakuId.value = form.value.koyou_keiyaku_id ?? null
          Logger.debug('日直申請より就業場所（雇用契約）と就業時間を初期化しました', { '雇用契約ID': koyouKeiyakuId.value, '就業時間ID': workTimeId.value })
        }
        isInit.value = true
        Logger.debug('日直申請コンポーネントの初期化完了\n----------------------------')
      })
    })

    // 行追加
    const addRow = () => {
      const row: Nittyoku = {
        shinsei_date: null
      }
      addRowNoRef(form.value.nittyoku, row)
    }

    // 就業場所・就業時間が変更された場合に走る処理
    // 引数は以下コンポーネントのemits.changeに準拠
    // src/resources/ts/components/shinsei/create/parts/KoyouKeiyakuTimeSelect.vue
    const changeKoyouKeiyakuTime = (emitData: KoyouKeiyakuTimeSelectEmitData) => {
      // 就業場所に関する情報をemitする（申請オブジェクトの変更等は親に移譲する）
      context.emit('changeKoyouKeiyakuTime', emitData.selectedSyuugyouBasyo, null);
    }
    return {
      getError,
      addRow,
      removeTableRow,
      isInit,
      changeKoyouKeiyakuTime
    }
  },
  components: {
    'koyouKeiyakuTimeSelect': KoyouKeiyakuTimeSelect
  }
})

</script>
<style lang="scss" scoped>
@import '@scss/components/shinsei-create.scss';
</style>